import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { memo } from "react";
import { formatCPF } from "@/shared/lib/formatters";
import type { SellerResponseDTO } from "../types/seller.types";

interface SellerDeleteDialogProps {
  open: boolean;
  loading: boolean;
  seller: SellerResponseDTO | null;
  onClose: () => void;
  onConfirm: () => void;
}

const formatDocument = (document: string) => {
  const raw = document.replace(/\D/g, "");
  return raw.length === 11 ? formatCPF(raw) : document;
};

export const SellerDeleteDialog = memo(function SellerDeleteDialog({
  open,
  loading,
  seller,
  onClose,
  onConfirm,
}: SellerDeleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Excluir Vendedor</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja excluir este vendedor?
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <div className="p-4 bg-destructive/10 rounded-md border border-destructive/20">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold">{seller?.name}</p>
                <p className="text-sm text-muted-foreground">
                  CPF:{" "}
                  {seller?.document ? formatDocument(seller.document) : "—"}
                </p>
                <p className="text-sm text-destructive mt-2">
                  Esta ação não pode ser desfeita!
                </p>
              </div>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? "Excluindo..." : "Excluir Vendedor"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});
